import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { inject, observer } from "mobx-react";
import moment from "moment";
import Cookies from "js-cookie";
import { sendMetriks } from "Services/sendMetriks";
import { TARIFF_TV } from "Services/queries";
import { OfferLayout as MicroMarkupOfferLayout } from "Layouts/MicroMarkup";
import ChannelsContainer from "Containers/ChannelsContainer";
import ConnectButton from "Containers/Buttons/ConnectButton";
import {
	TariffInfo,
	TariffName,
	BenefitsList,
	MinutesComponent,
	InternetComponent,
	SmsComponent,
	Comments,
	PriceComponent,
	ProviderLogo,
	Button,
	TarifficationCItem,
} from "ComponentsUI/TarifficationC";
import ElitePopup from "ComponentsUI/ElitePopup";
import { ModalLayout } from "ComponentsUI/Modallayout";
import { UnlimitedSocial } from "designSystem/UnlimetedSocial";
import { getSocialNetworksTexts } from "Helpers/localeText";
import { DodyAccordionList } from "ComponentsUI/DodyAccordionList";
import { getDeclination } from "Utils/text";

@inject("ApplicationModel")
@observer
class PlanCRowContainer extends Component {
	constructor(props) {
		super(props);
	}

	closeModal() {
		let modalModel = this.props.ApplicationModel.modalModel;
		if (modalModel.isOpen) {
			modalModel.toggleModal();
		}
	}

	onClickAddHandlerTv() {
		if (!!this.props.tariff.tv.use_text) {
			return null;
		}

		this.closeModal();
		let modalModel = this.props.ApplicationModel.modalModel;
		let channelContainer = import("Containers/ChannelsContainer");
		let apolloTariffQueryPromise = this.props.ApplicationModel.apolloTransportLayer.query({
			query: TARIFF_TV,
			variables: {
				id: this.props.tariff.id,
			},
		});
		Promise.all([channelContainer, apolloTariffQueryPromise]).then((module) => {
			let ChannelContainer = module[0].default;
			let tariff = module[1].data.tariffsOne;

			modalModel.toggleModal(
				<ModalLayout closeModal={() => this.closeModal()}>
					<ChannelsContainer tariff={tariff} />
				</ModalLayout>
			);
		});
	}

	clickConnectHandler() {
		let {
			ApplicationModel: { tariffsModel, sendingStore },
			tariff,
		} = this.props;
		let licenseFree = false;
		let connectTariffButton =
			this.props.ApplicationModel?.siteConfig?.settings?.connect_tariff_button?.[
				this.props.pageName
			] || "connect";

		tariffsModel.setTariff(tariff);

		if (
			tariff?.after?.data?.price?.license_fee_month &&
			tariff?.after?.data?.price?.license_fee_month !== tariff.price.license_fee
		) {
			licenseFree = true;
		}
		if (licenseFree && connectTariffButton === "connect") {
			sendMetriks("CLICK_CONNECT_WITH_ACTION");
		}

		if (this.props.isRegionRatesTag && connectTariffButton === "check_coverage") {
			sendMetriks("CLICK_CHECK_ADDRESS_RATES_TAG");
		}

		if (this.props.isRegionRatesTag && connectTariffButton === "connect") {
			sendMetriks("CLICK_CONNECT_TARIFF_FROM_TAG_RATES");
		}

		if (this.props.isProviderRatesTag && connectTariffButton === "connect") {
			sendMetriks("CLICK_CONNECT_TARIF_FROM_TAG_KARTOCHKA_RATES");
		}
		if (this.props.isProviderRatesTag && connectTariffButton === "check_coverage") {
			sendMetriks("CLICK_CHECK_ADDRESS_RATES_TAG_PROVIDER");
		}

		if (
			this.props.tariff?.provider?.vip_provider == 1 &&
			this.props.tariff?.provider?.provider_settings?.tariffs?.value === "button_text" &&
			connectTariffButton === "connect"
		) {
			sendMetriks("CLICK_NEW_TEXT");
		}

		const dataLogs = {
			click_on_page: "open_connect_tariff",
		};
		sendingStore.sendClientAction(dataLogs);

		if (this.props.isProviderRatesTag) {
			Cookies.set("connectTariffFrom", "tag_rates_provider");
		} else if (this.props.isRegionRatesTag) {
			Cookies.set("connectTariffFrom", "rates_tags");
		}
	}

	onClickHref = () => {
		window.open(this.props.tariff.provider.contacts.link, "_blank");

		return false;
	};

	isNoEmptyObject(object) {
		for (let key in object) {
			if (object[key] == 1) {
				return true;
			}
		}
		return false;
	}

	render() {
		const {
			ApplicationModel: { text, siteConfig },
			tariff,
			skipLayout,
		} = this.props;
		const benefitItems = [];
		let unlimitedSocialData = tariff?.social_unlim || null;
		let unlimitedSocial = null;
		let minutesComponent;
		let internetComponent;
		let smsComponent;

		// Информация об интернете
		if (tariff.internet && tariff.internet.speed_in) {
			benefitItems.push({
				beginningText: `${text.servicesHomeInternet}: `,
				name: tariff.internet.speed_in,
				measure: ` ${text.MB_PER_SECOND}`,
				icon: "icon-router",
			});
		}

		// Информация о ТВ
		if (!!tariff.tv && (tariff.tv.channels || tariff.tv.channels_hd)) {
			let point = !tariff.tv.use_text;
			let channels = tariff.tv.channels ? tariff.tv.channels : null;
			if (tariff.tv.channels_hd) {
				channels = !!channels
					? `${channels} + ${tariff.tv.channels_hd}HD`
					: `${tariff.tv.channels_hd}HD`;
			}

			const channelsCount = (tariff.tv.channels || 0) + (tariff.tv.channels_hd || 0);

			benefitItems.push({
				beginningText: `${text.services_TV_2}: `,
				name: channels,
				measure: ` ${getDeclination(
					channelsCount,
					text.SERVICES_CHANNEL_DECLINATION.ONE,
					text.SERVICES_CHANNEL_DECLINATION.TWO,
					text.SERVICES_CHANNEL_DECLINATION.FIVE
				)}`,
				icon: "icon-tv",
				point: point,
				onClickHandler: () => this.onClickAddHandlerTv(),
			});
		}

		// Информаци о цене
		let priceComments = [];
		let dodyPrice = null;
		if (
			tariff?.after?.data.price?.license_fee_month &&
			tariff.after.data.price.license_fee_month !== tariff.price.license_fee
		) {
			let textTimeGracePeriod = "";

			if (tariff.after?.rule?.code == "after_date") {
				textTimeGracePeriod = `до\u00a0${moment(tariff.after?.rule?.date_end).format(
					"D MMMM YYYY"
				)}`;
			} else {
				textTimeGracePeriod = `${tariff.after.rule.month_cnt}\u00a0${text.SERVICES_MONTH}`;
			}

			priceComments = [`${text.ORDER_FORM_GRACE_PERIOD_TITLE}: ${textTimeGracePeriod}`];
			dodyPrice = {
				name: text.period_action_price,
				short_description: textTimeGracePeriod,
				className: "itemPrice",
			};
		}

		let priceComponent = (
			<PriceComponent
				displayPrice={tariff.displayPrice}
				licenceFeeBoolean={tariff.displayPrice != tariff.price.license_fee}
				licenseFee={tariff.price.license_fee}
				measure={text.PRICE_IN_MONTH}
				comments={priceComments}
			/>
		);

		let dodySetupPrice = !!tariff?.connection?.price
			? {
					name: text.comparisonCostConnect,
					short_description: `${text.one_payment_tariff_activation}${tariff.connection.price}\u00a0${text.servicesRub}`,
				}
			: null;
		let dodyPrepaid = !!tariff?.price?.system_calculation_connect
			? {
					name: text.advance_payment,
					short_description: `${text.advance_payment_in_connect}${tariff.price.system_calculation_connect}\u00a0${text.servicesRub}`,
				}
			: null;

		let additionalDody = [dodySetupPrice, dodyPrepaid, dodyPrice];
		let additionalDescription = tariff.addition_description
			? Object.keys(tariff.addition_description).map((elem) => {
					if (elem === "__typename" || !tariff.addition_description?.[elem]) {
						return null;
					}
					return {
						name: text.addition_description[elem],
						short_description: tariff.addition_description[elem],
					};
				})
			: [];

		// Логотип
		let logoComponent = <ProviderLogo path={tariff.provider.logo_2} name={tariff.provider.name} />;

		let linkComponent = <Link to={"/"} />;

		// Эксклюзив
		let eliteComponent = !!tariff.is_exclusive ? (
			<ElitePopup text1={text.exclusive_tariff} flatV2={true} />
		) : null;

		const tariffInfo = (
			<TariffInfo
				tariffName={<TariffName name={tariff.name} />}
				shortDescription={tariff.short_description}
				logoComponent={logoComponent}
				linkComponent={linkComponent}
				tariff={tariff}
				benefitsList={<BenefitsList items={benefitItems} />}
				dodyList={
					<DodyAccordionList
						dody={tariff.dody}
						additionalDescription={additionalDescription}
						additionalDody={additionalDody}
					/>
				}
				generateProviderRates={this.props.generateProviderRates}
			/>
		);

		// Комментарий к интернету
		let internetComment = [
			<Comments key="internetComments" message={text.service_mobile_internet} type={2} />,
		];

		//Информация о мобилке
		if (!!tariff.mobile_new) {
			let smsType = tariff.mobile_new.sms_type;
			let minutesComments = null;
			if (smsType == 1 || smsType == 2) {
				minutesComments = [
					<Comments
						key="minutesComments"
						value={`+ ${tariff.mobile_new.sms}`}
						message={text.message}
						type={smsType}
					/>,
				];
			}

			let callType = tariff.mobile_new.calls_type;
			minutesComponent = (
				<MinutesComponent
					type={callType}
					value={+tariff.mobile_new.calls}
					measure={text.min}
					comments={minutesComments}
				/>
			);

			const socialNetworksTexts = getSocialNetworksTexts(text);

			const socialData =
				unlimitedSocialData &&
				Object.entries(unlimitedSocialData)
					.filter(([, value]) => value === 1)
					.map(([key]) => ({
						key,
						tooltipText: socialNetworksTexts[key],
					}));

			//Информация о безлимитных сервисах
			unlimitedSocial = this.isNoEmptyObject(unlimitedSocialData) ? (
				<UnlimitedSocial header={text.unlim} socialData={socialData} />
			) : null;
			internetComment.push(unlimitedSocial);

			let internetType = tariff.mobile_new.internet_type;
			internetComponent = (
				<InternetComponent
					type={internetType}
					value={+tariff.mobile_new.internet}
					measure={text.GB}
					comments={internetComment}
				/>
			);

			smsComponent = (
				<SmsComponent type={smsType} value={+tariff.mobile_new.sms} measure={text.sms} />
			);
		} else {
			minutesComponent = <MinutesComponent measure={text.min} />;
			internetComponent = <InternetComponent measure={text.GB} comments={internetComment} />;
			smsComponent = <SmsComponent measure={text.sms} />;
		}

		const isSale =
			tariff?.after?.data?.price?.license_fee_month &&
			tariff?.after?.data?.price?.license_fee_month !== tariff.price.license_fee;

		let buttonConnect = (
			<ConnectButton
				data={tariff}
				showConnectAction={isSale}
				isRatesTag={this.props.isRatesTag}
				onClickHref={this.onClickHref}
				pageName={this.props.pageName}
			/>
		);
		let button = (
			<Button
				connectButtonDatatest={"button_form_inspect_connect_tariff_tag_button"}
				buttonConnectComponent={buttonConnect}
				isRatesTag={true}
			/>
		);

		return (
			<MicroMarkupOfferLayout tariff={tariff} siteConfig={siteConfig} skipLayout={skipLayout}>
				<TarifficationCItem
					tariff={tariff}
					tariffInfo={tariffInfo}
					unlimitedSocial={unlimitedSocial}
					minutesComponent={minutesComponent}
					internetComponent={internetComponent}
					smsComponent={smsComponent}
					priceComponent={priceComponent}
					logoComponent={logoComponent}
					buttons={button}
					onClickConnect={() => this.clickConnectHandler()}
					linkComponent={linkComponent}
					generateProviderRates={this.props.generateProviderRates}
					eliteComponent={eliteComponent}
				/>
			</MicroMarkupOfferLayout>
		);
	}
}

export default withRouter(PlanCRowContainer);
